import React from 'react';
import './ProductList.css';
import Product from '../product/Product';
import { products } from '../../data'

function ProductList() {
    return (
        <div className="pl">
            <div className="pl-texts">
                <h1 className="pl-title">Trying to be better at learning more</h1>
                <p className="pl-desc">
                    I am trying to better learn more about web development making things with ReactJS and NodeJS.
                    Always can learn new things about technology and programming.
                </p>
            </div>
            <div className="pl-list">
                {products.map(item => (
                    <Product key={item.id} img={item.img} link={item.link} />
                ))}


            </div>
        </div>
    )
}

export default ProductList